/* ============================================================
   Flooring Fitted — category-aware configurator (real YMQ pricing,
   pulled from the live store 5 Jul 2026). Estimates use raw L×W area
   (matching YMQ — no wastage uplift). Display-only: checkout charges
   the £30 survey deposit; the balance is a manual draft order.
   Selections sync into hidden line-item property inputs bound to
   Dawn's product form via the form="" attribute.
   ============================================================ */
(function () {
  var room = document.querySelector('[data-ff-room]');
  var cfg = document.querySelector('[data-ff-cfg]');
  var total = document.querySelector('[data-ff-total]');
  if (!room || !total) return;

  var lengthIn = room.querySelector('[data-ff-length]');
  var widthIn = room.querySelector('[data-ff-width]');
  var m2Out = room.querySelector('[data-ff-m2]');
  var materialsOut = total.querySelector('[data-ff-materials]');
  var fittingOut = total.querySelector('[data-ff-fitting]');
  var grandOut = total.querySelector('[data-ff-grand]');

  var supply = parseInt(total.dataset.supplyPence, 10) / 100 || 0;
  var cat = cfg ? cfg.dataset.category : 'lvt';

  // Hide rows that don't apply to this category
  if (cfg) {
    cfg.querySelectorAll('[data-cfg-show]').forEach(function (row) {
      if (row.dataset.cfgShow.split(' ').indexOf(cat) === -1) row.style.display = 'none';
    });
    cfg.querySelectorAll('[data-cfg-underlay]').forEach(function (tiles) {
      var wanted = cat === 'carpet' ? 'carpet' : 'wood';
      if (tiles.dataset.cfgUnderlay !== wanted) tiles.style.display = 'none';
    });
    // Renumber the visible steps so the gold numbers stay sequential
    var n = 2;
    cfg.querySelectorAll('.ff-cfg__row').forEach(function (row) {
      if (row.style.display === 'none') return;
      var num = row.querySelector('.ff-cfg__n');
      if (num) num.textContent = (n < 10 ? '0' : '') + n;
      n++;
    });
  }

  var d = cfg ? cfg.dataset : {};
  var R = {
    fitting: parseFloat(d.fittingRate) || 0,
    prepLeveling: parseFloat(d.prepLeveling) || 0,
    prepPlywood: parseFloat(d.prepPlywood) || 0,
    adhesive: parseFloat(d.adhesiveRate) || 0,
    underlayC1: parseFloat(d.underlayC1) || 0,
    underlayC2: parseFloat(d.underlayC2) || 0,
    underlayC3: parseFloat(d.underlayC3) || 0,
    underlayW1: parseFloat(d.underlayW1) || 0,
    underlayW2: parseFloat(d.underlayW2) || 0,
    underlayW3: parseFloat(d.underlayW3) || 0,
    gripper: parseFloat(d.gripperRate) || 0,
    scotia: parseFloat(d.scotiaRate) || 0,
    doorbarEach: parseFloat(d.doorbarEach) || 0,
    removalTakeup: parseFloat(d.removalTakeup) || 0,
    removalDispose: parseFloat(d.removalDispose) || 0,
    removalBoth: parseFloat(d.removalBoth) || 0
  };

  var money = function (n) { return '£' + (Math.round(n * 100) / 100).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };
  var moneyRound = function (n) { return '£' + Math.round(n).toLocaleString('en-GB'); };
  var boxM2 = cfg ? parseFloat(cfg.dataset.boxM2) || 0 : 0;
  // Blank line-item properties that carry no information (keeps the cart clean)
  var propOrBlank = function (v) { return v === 'n/a' || v === 'none' || v === 'No' || v === '0' ? '' : v; };

  var doorbars = 0;
  var lastExtras = 0; // fitting + extras from the most recent recalc
  var visible = function (name) { var el = cfg.querySelector('[data-cfg="' + name + '"]'); return el && el.closest('.ff-cfg__row').style.display !== 'none'; };
  var checkedSel = function (name) {
    var els = [...cfg.querySelectorAll('[data-cfg="' + name + '"]:checked')];
    return els.find(function (e) { return e.closest('[data-cfg-underlay]') === null || e.closest('[data-cfg-underlay]').style.display !== 'none'; }) || null;
  };
  var isOn = function (name) { var el = cfg.querySelector('[data-cfg="' + name + '"]'); return el ? el.checked : false; };
  var setText = function (sel, txt) { var el = cfg.querySelector(sel) || total.querySelector(sel); if (el) el.textContent = txt; };
  var setProp = function (key, val) { var el = cfg.querySelector('[data-cfg-prop="' + key + '"]'); if (el) el.value = val; };
  var rateOf = function (el) { return el ? (el.dataset.rateKey ? R[el.dataset.rateKey] : parseFloat(el.dataset.rate) || 0) : 0; };

  function recalc() {
    var l = parseFloat(lengthIn.value) || 0;
    var w = parseFloat(widthIn.value) || 0;
    var m2 = +(l * w).toFixed(2);
    m2Out.textContent = m2 ? m2.toFixed(2) : '0';

    var materials = m2 * supply;
    var extras = 0;

    if (cfg) {
      setText('[data-cfg-price="fitting-yes"]', '+' + money(m2 * R.fitting));
      setText('[data-cfg-price="prep-leveling"]', '+' + money(m2 * R.prepLeveling));
      setText('[data-cfg-price="prep-plywood"]', '+' + money(m2 * R.prepPlywood));
      setText('[data-cfg-price="adhesive"]', '+' + money(m2 * R.adhesive));
      setText('[data-cfg-price="underlay-1"]', '+' + money(m2 * R.underlayC1));
      setText('[data-cfg-price="underlay-2"]', '+' + money(m2 * R.underlayC2));
      setText('[data-cfg-price="underlay-3"]', '+' + money(m2 * R.underlayC3));
      setText('[data-cfg-price="underlay-w1"]', '+' + money(m2 * R.underlayW1));
      setText('[data-cfg-price="underlay-w2"]', '+' + money(m2 * R.underlayW2));
      setText('[data-cfg-price="underlay-w3"]', '+' + money(m2 * R.underlayW3));
      setText('[data-cfg-price="gripper"]', '+' + money(m2 * R.gripper));
      setText('[data-cfg-price="scotia"]', '+' + money(m2 * R.scotia));
      setText('[data-cfg-price="removal-takeup"]', '+' + money(m2 * R.removalTakeup));
      setText('[data-cfg-price="removal-dispose"]', '+' + money(m2 * R.removalDispose));
      setText('[data-cfg-price="removal-both"]', '+' + money(m2 * R.removalBoth));
      setText('[data-cfg-price="doorbar-each"]', money(R.doorbarEach));

      var fitted = checkedSel('fitting') && checkedSel('fitting').value === 'fitted';
      var fitting = fitted ? m2 * R.fitting : 0;

      var prepSel = visible('prep') ? checkedSel('prep') : null;
      var prep = m2 * rateOf(prepSel);

      var underSel = visible('underlay') ? checkedSel('underlay') : null;
      var underlay = m2 * rateOf(underSel);

      var gripper = visible('gripper') && isOn('gripper') ? m2 * R.gripper : 0;
      var adhesive = visible('adhesive') && isOn('adhesive') ? m2 * R.adhesive : 0;
      var scotia = visible('scotia') && isOn('scotia') ? m2 * R.scotia : 0;

      var doorbarCost = doorbars * R.doorbarEach;
      setText('[data-cfg-price="doorbars"]', money(doorbarCost));

      var remSel = checkedSel('removal');
      var removal = m2 * rateOf(remSel);

      extras = fitting + prep + adhesive + underlay + gripper + scotia + doorbarCost + removal;

      setText('[data-cfg-sum="fitting"]', fitted ? 'FITTED · +' + money(fitting) : 'SUPPLY ONLY');
      setText('[data-cfg-sum="prep"]', prepSel && prepSel.value !== 'none' ? prepSel.value.toUpperCase() + ' · +' + money(prep) : 'NONE');
      setText('[data-cfg-sum="underlay"]', underSel && underSel.value !== 'none' ? underSel.value.toUpperCase() + ' · +' + money(underlay) : 'NONE');
      setText('[data-cfg-sum="removal"]', remSel && remSel.value !== 'none' ? remSel.value.toUpperCase() + ' · +' + money(removal) : 'NONE');

      setProp('room', l && w ? l + 'm × ' + w + 'm · ' + m2.toFixed(2) + 'm²' : '');
      setProp('fitting', fitted ? 'Professional fitting' : 'Supply only');
      setProp('prep', propOrBlank(prepSel ? prepSel.value : 'n/a'));
      setProp('adhesive', propOrBlank(visible('adhesive') ? (isOn('adhesive') ? 'Yes' : 'No') : 'n/a'));
      setProp('underlay', propOrBlank(underSel ? underSel.value : 'n/a'));
      setProp('gripper', propOrBlank(visible('gripper') ? (isOn('gripper') ? 'Yes' : 'No') : 'n/a'));
      setProp('scotia', propOrBlank(visible('scotia') ? (isOn('scotia') ? 'Yes' : 'No') : 'n/a'));
      setProp('doorbars', propOrBlank(String(doorbars)));
      setProp('removal', propOrBlank(remSel ? remSel.value : 'none'));
      setProp('estimate', m2 ? moneyRound(materials + extras) : '');

      // Cart quantity: enough m² (or boxes) to cover the room
      var qtyInput = document.querySelector('[data-cfg-qty]');
      if (qtyInput) qtyInput.value = m2 ? Math.max(1, Math.ceil(boxM2 > 0 ? m2 / boxM2 : m2)) : 1;
    }

    lastExtras = m2 ? extras : 0;
    materialsOut.textContent = m2 ? moneyRound(materials) : '£—';
    fittingOut.textContent = m2 ? moneyRound(extras) : '£—';
    grandOut.textContent = m2 ? moneyRound(materials + extras) : '£—';
  }

  [lengthIn, widthIn].forEach(function (el) { el.addEventListener('input', recalc); el.addEventListener('change', recalc); });

  if (cfg) {
    cfg.addEventListener('change', recalc);
    cfg.querySelectorAll('[data-cfg-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        doorbars = Math.max(0, Math.min(4, doorbars + parseInt(btn.dataset.cfgStep, 10)));
        cfg.querySelector('[data-cfg-count]').textContent = doorbars;
        recalc();
      });
    });
  }

  recalc();

  // "Continue to survey" adds the configured floor to the cart (carrying
  // every selection as line-item properties) and goes straight to the
  // survey-choice screen — book a £30 survey, or pay now and settle any
  // difference after the visit. It deliberately bypasses the cart drawer.
  var proxy = total.querySelector('[data-ff-continue]');
  var realSubmit = document.querySelector('.product-form__submit');
  if (proxy && realSubmit) {
    document.documentElement.classList.add('ff-js-proxy');
    var nextUrl = total.dataset.continueUrl || '/pages/quote';

    proxy.addEventListener('click', function () {
      var form = realSubmit.closest('form');
      if (!form) return;

      if (!parseFloat(lengthIn.value) || !parseFloat(widthIn.value)) {
        [lengthIn, widthIn].forEach(function (el) { if (!parseFloat(el.value)) el.style.borderColor = 'var(--warn)'; });
        room.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      var label = proxy.innerHTML;
      proxy.disabled = true;
      proxy.textContent = 'Adding…';

      // Line 1: the flooring, quantity already scaled to the room
      var props = {};
      cfg && cfg.querySelectorAll('[data-cfg-prop]').forEach(function (el) {
        var name = (el.name.match(/\[(.+)\]/) || [])[1];
        if (name && el.value) props[name] = el.value;
      });
      var items = [{
        id: parseInt(form.querySelector('[name="id"]').value, 10),
        quantity: parseInt((cfg && cfg.querySelector('[data-cfg-qty]').value) || 1, 10),
        properties: props
      }];

      // Line 2: fitting + extras, charged as N × a £1 product so the
      // pay-now path bills the full fitted price (Basic plan has no way
      // to add an arbitrary amount at checkout)
      var fitVariant = total.dataset.fittingVariant;
      var fitUnit = parseFloat(total.dataset.fittingUnit) || 1;
      if (fitVariant && lastExtras > 0) {
        var units = Math.round(lastExtras / fitUnit);
        if (units > 0) {
          items.push({
            id: parseInt(fitVariant, 10),
            quantity: units,
            properties: { 'Fitting for': document.title.split('–')[0].trim(), 'Room': props['Room size'] || '' }
          });
        }
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
        .then(function () { window.location.href = nextUrl; })
        .catch(function () {
          proxy.disabled = false;
          proxy.innerHTML = label;
          // fall back to the theme's own add-to-cart so the click is never lost
          if (form.requestSubmit) form.requestSubmit(realSubmit); else realSubmit.click();
        });
    });
  }
})();
